import { Entity } from '@backstage/catalog-model';
import { LinkData } from '../../util';

const getTitle = (channel: Channel) => {
  const name = channel.url?.split('/')?.pop();
  let title = `#${name}`;
  if (channel.mention) {
    title += ` (mention: @${channel.mention})`;
  }
  return title;
};

export type Channel = {
  role: string;
  url: string;
  mention: string;
};

export const slackLinks = (entity: Entity): LinkData[] => {
  const channels = entity.metadata?.channels as Channel[];

  if (!channels) {
    return [];
  }

  return channels
    .filter(channel => channel.role === 'slack')
    .map(channel => ({
      title: getTitle(channel),
      url: channel.url,
    }));
};

export const uniqueSlackLinks = (allChannels: LinkData[]): LinkData[] => {
  const uniqueChannels: LinkData[] = [];

  allChannels.forEach(channel => {
    if (!uniqueChannels.some(c => c.title === channel.title)) {
      uniqueChannels.push(channel);
    }
  });

  return uniqueChannels;
};
